export default function ArrowUpRightMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="100%" height="100%" fill="white" />
            <path d="M872 872H690.039V438.513L256.666 872L128 743.3L561.179 310.009L128.195 310.009V128H690.039H872V310.009V872Z" fill="#1C5DCC" />
        </svg>

    )
}